import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCGuidePopover, useMediaQuery } from '@reverbdotcom/cadence/components';
import { getItem, setItem } from '@reverbdotcom/commons/src/local_storage_utils';

const CALLOUT_KEY = 'hoist-favorite-callout';
const CALLOUT_LIFETIME_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

export function HoistFavoriteCallout({ anchor }: { anchor: JSX.Element }) {
  const isMobile = useMediaQuery('mobile');
  const [calloutTimestampValue, setCalloutTimestampValue] = useState(getItem(CALLOUT_KEY) || '0');

  const title = I18n.t('discovery.favorites.hoistFavoriteCallout.title');
  const content = I18n.t('discovery.favorites.hoistFavoriteCallout.content');
  const mobileTitle = <>
    {title + '.'}
    <br /><br />
    {content}
  </>;

  const currentTimestamp = Date.now();
  const calloutTimestamp = parseInt(calloutTimestampValue, 10);
  const calloutLifetime = (currentTimestamp - calloutTimestamp);

  const isOpen = calloutLifetime > CALLOUT_LIFETIME_MS;

  return (
    <RCGuidePopover
      title={!isMobile ? title : mobileTitle}
      content={content}
      isOpen={isOpen}
      width="narrow"
      onDismiss={() => {
        const newTimestamp = Date.now();

        setItem(CALLOUT_KEY, newTimestamp.toString());
        setCalloutTimestampValue(newTimestamp.toString());
      }}
      anchor={anchor}
      preventAutoFocus
    />
  );
}